import { supabase } from "@/lib/supabase";

/**
 * 공개 폼 제출 — Edge Function kangstudy-submit 경유.
 *
 * 원래 5개 폼(상담·교육신청·리포트·뉴스레터·강의문의)이 readdy.ai form API 로
 * 고객 정보를 POST 했다. 자체 DB(kangstudy_form_submissions)로 옮기면서,
 * 테이블은 RLS 로 잠그고(anon 정책 0개) 이 함수가 서버 대행을 부른다.
 *
 * 반환은 {ok, error} — 호출부의 기존 success/error 분기를 그대로 살리기 위해
 * 던지지 않는다.
 */
export type KangstudyFormType =
  | "consultation"
  | "course_registration"
  | "report_download"
  | "newsletter"
  | "lecture_inquiry";

export async function submitKangstudyForm(
  formType: KangstudyFormType,
  data: Record<string, string>,
): Promise<{ ok: boolean; error: string }> {
  try {
    const { data: res, error } = await supabase.functions.invoke("kangstudy-submit", {
      body: { form_type: formType, data },
    });

    if (error) {
      // FunctionsHttpError 는 본문에 우리 한국어 메시지를 담고 있다.
      const ctx = (error as { context?: Response }).context;
      if (ctx && typeof ctx.json === "function") {
        try {
          const payload = await ctx.json();
          if (payload?.error) return { ok: false, error: String(payload.error) };
        } catch {
          /* 본문이 JSON 이 아니면 아래 일반 메시지로 */
        }
      }
      return { ok: false, error: "제출 중 오류가 발생했습니다. 다시 시도해주세요." };
    }

    const payload = (res ?? {}) as { ok?: boolean; error?: string };
    if (payload.error) return { ok: false, error: payload.error };
    return { ok: true, error: "" };
  } catch {
    return { ok: false, error: "네트워크 오류가 발생했습니다. 다시 시도해주세요." };
  }
}

/** FormData → 문자열 레코드 (파일 등 비문자열은 버린다). */
export function formDataToRecord(fd: FormData): Record<string, string> {
  const out: Record<string, string> = {};
  fd.forEach((v, k) => {
    if (typeof v === "string") out[k] = v;
  });
  return out;
}
